import type { Placement } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useStore } from 'zustand';
import { centerPlacementOnAxis, useEditAreaDraftStore } from '@/entities/edit-area';
import { applyEditAreaCommand } from '../model/apply-edit-area-command';
import { PlacementInspector } from './placement-inspector';

interface PlacementItemProps {
  readonly placement: Placement;
}

/** 선택한 인쇄 영역의 이 면 배치 — 가운데 정렬. 위치는 사진 위에서 끌어 옮기고, 이 면에서 지우기는 [인쇄 영역 삭제]·Delete 키로 한다. */
export const PlacementItem = ({ placement }: PlacementItemProps): ReactElement => {
  const store = useEditAreaDraftStore();
  const state = useStore(store);
  const component = state.components.find((item) => item.id === placement.componentId);
  const surface = state.faces[state.selection.face]?.surfaces.find(
    (item) => item.id === placement.surfaceId,
  );
  // 두 축을 모두 가운데로 둔 위치. 인스펙터가 버튼마다 한 축씩 꺼내 쓴다.
  const centeredPosition =
    component && surface
      ? centerPlacementOnAxis(
          component,
          surface,
          centerPlacementOnAxis(component, surface, placement.position, 'x'),
          'y',
        )
      : null;
  return (
    <div className="rounded border p-3">
      <PlacementInspector
        key={`${state.generation}:${JSON.stringify(placement)}`}
        placement={placement}
        centeredPosition={centeredPosition}
        disabled={state.locked || state.isUnsupported}
        onApply={(next) =>
          applyEditAreaCommand(store, () => state.upsertPlacement(state.selection.face, next))
        }
      />
    </div>
  );
};
